import React from 'react'
import { TextArea, Grid, Popup } from 'semantic-ui-react'

const { Row, Column } = Grid

const TextareaField = ({
  after,
  before,
  children,
  className,
  disabled,
  error,
  label,
  onChange,
  required,
  tooltip,
  validated,
  value,
}) => (
  <Row className={`field ${className}${required ? ' required' : ''}`}>
    {className !== 'large' && <Column width={4}><span className="field-label">{label}: </span></Column>}
    <Column width={className === 'large' ? 12 : 8}>
      {before}
      {!disabled
        ? <TextArea
          name={name}
          onChange={(e, event) => onChange(event)}
          required={required || undefined}
          value={value}
        />
        : <p className="textarea">{value}</p>
      }
      {after}
      {!!tooltip &&
        <Popup
          trigger={<i className="daicon daicon-Help tooltip" />}
          content={tooltip}
          position="right center"
        />

      }
    </Column>
    <Column width={4}>
      {!!error &&
        <Popup
          trigger={<i className="daicon daicon-Attention error" />}
          content={error}
          position="right center"
        />
      }

      {validated && !error &&
        <i className="daicon daicon-Checkmark success" />
      }
      {children}
    </Column>
  </Row>
)

TextareaField.defaultProps = {
  after: null,
  before: null,
  children: null,
  className: '',
  disabled: false,
  error: '',
  label: '',
  required: false,
  tooltip: '',
  validated: false,
}

TextareaField.propTypes = {
  after: React.PropTypes.any,
  before: React.PropTypes.any,
  children: React.PropTypes.any,
  className: React.PropTypes.string,
  disabled: React.PropTypes.any,
  error: React.PropTypes.string,
  label: React.PropTypes.string,
  name: React.PropTypes.string.isRequired,
  onChange: React.PropTypes.func.isRequired,
  required: React.PropTypes.bool,
  tooltip: React.PropTypes.string,
  validated: React.PropTypes.bool,
  value: React.PropTypes.string.isRequired,
}

export default TextareaField



// WEBPACK FOOTER //
// ./src/browser/components/fields/Textarea.js